export const OFFER_CONTRACT_STATUS_ERROR_MESSAGES = Object.freeze({
  404: 'Contrato não encontrado. Atualize a proposta antes de tentar novamente.',
  429: 'Provider de assinatura atingiu o limite de requisições. Aguarde alguns minutos e tente sincronizar novamente.',
  502: 'Provider de assinatura indisponível no momento. Tente sincronizar novamente em instantes.',
});

export const normalizeContractCancelReason = reason =>
  String(reason || '').trim();

export const contractCancelPayload = reason => {
  const cancellationReason = normalizeContractCancelReason(reason);
  return cancellationReason ? { cancellation_reason: cancellationReason } : {};
};

export const contractOperationErrorMessage = (
  error,
  fallback = 'Não foi possível atualizar o contrato.'
) => {
  const status = Number(error?.response?.status);
  if (OFFER_CONTRACT_STATUS_ERROR_MESSAGES[status]) {
    return OFFER_CONTRACT_STATUS_ERROR_MESSAGES[status];
  }

  const errors = error?.response?.data?.errors;
  if (Array.isArray(errors) && errors.length) return errors.join(', ');

  return error?.response?.data?.message || fallback;
};
